import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  mt: 1,
  background: (p) => p.palette.grey[100],
  padding: (p) => p.spacing(1, 2),
  borderRadius: (p) => p.spacing(1),
};

export const button: SxStyle = {
  background: (p) => p.palette.common.white,
};
